export async function fetchManyWithConcurrency(items, fn, limit = 8) {
  const results = [];
  let i = 0;
  async function worker() {
    while (i < items.length) {
      const it = items[i++];
      try { results.push(await fn(it)); }
      catch (e) { console.warn("fetchMany item failed", it, e); }
    }
  }
  const n = Math.min(limit, Math.max(items.length, 0));
  await Promise.all(Array.from({ length: n }, worker));
  return results;
}

// Like Promise.allSettled but with a concurrency cap so we don't overrun the
// backend connection pool on bulk writes. Never rejects; returns one result per
// input item, in input order: { item, status: "fulfilled"|"rejected", value?, reason? }.
export async function settleWithConcurrency(items, fn, limit = 4) {
  const results = new Array(items.length);
  let i = 0;
  async function worker() {
    while (i < items.length) {
      const idx = i++;
      try {
        results[idx] = { item: items[idx], status: "fulfilled", value: await fn(items[idx]) };
      } catch (reason) {
        results[idx] = { item: items[idx], status: "rejected", reason };
      }
    }
  }
  const n = Math.min(Math.max(limit, 1), items.length);
  await Promise.all(Array.from({ length: n }, worker));
  return results;
}
